// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Placeholder__placeholder___nnhZf {\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/common/components/Placeholder/Placeholder.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".placeholder {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": "Placeholder__placeholder___nnhZf"
};
export default ___CSS_LOADER_EXPORT___;
